import { Box, Stack, TextField } from "@mui/material";
import React, { Dispatch, memo, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";

import FiltersActions from "../../../../components/FiltersActions/FiltersActions";
import useFilter from "../../../../hooks/useFilter";

import { DatePickerUncontrolled, DateRangeSelect } from "@4uhub/lib4uhub";

interface IMacroFilterProps {
  onFilterParams: Dispatch<SetStateAction<IFilterParams>>;
  filterParams: IFilterParams;
}

export interface IFilterParams {
  StartDate: Date | null;
  EndDate?: Date | null;
  ErrorCode: string;
  refresh?: boolean;
}

const translationPath = "page.4uBus.logs.externalLogError.";

const MacroFilter: React.FC<IMacroFilterProps> = ({
  onFilterParams,
  filterParams,
}) => {
  const { filter, showCleanBtn, initialState, setFilter, cleanFilter } =
    useFilter(filterParams);

  const { t } = useTranslation();
  const [resetDateRange, setResetDateRange] = useState(false);
  const [enableFields, setEnableFields] = useState(true);

  const filterHandler = () => {
    onFilterParams(filter);
  };

  const cleanHandler = () => {
    onFilterParams(initialState.current);
    cleanFilter();
    setResetDateRange((prev) => !prev);
  };

  return (
    <Stack flexDirection={"row"} gap={2} alignItems="center">
      <DateRangeSelect
        setEndDate={(date) => setFilter({ EndDate: date })}
        setStartDate={(date) => setFilter({ StartDate: date })}
        setEnableFields={setEnableFields}
        resetToToday={resetDateRange}
      />
      <Box sx={{ flex: "0 0 160px" }}>
        <DatePickerUncontrolled
          value={filter.StartDate}
          onChange={(date) => setFilter({ StartDate: date })}
          label={`${t(translationPath + "start_date")}`}
          isClearable={false}
          disable={enableFields}
        />
      </Box>
      <Box sx={{ flex: "0 0 160px" }}>
        <DatePickerUncontrolled
          value={filter.EndDate}
          onChange={(date) => setFilter({ EndDate: date })}
          label={`${t(translationPath + "end_date")}`}
          isClearable={false}
          disable={enableFields}
        />
      </Box>
      <TextField
        value={filter.ErrorCode}
        size="small"
        label={t(translationPath + "error_code")}
        fullWidth
        onChange={(e) => setFilter({ ErrorCode: e.target.value })}
      />
      <FiltersActions
        onFilter={filterHandler}
        onClean={cleanHandler}
        showCleanBtn={showCleanBtn}
      />
    </Stack>
  );
};

export default memo(MacroFilter);
